import React, { memo } from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { useCart } from "../../context/CartContext";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL } from "../../api/api";
import "./FoodCard.css";

const FoodCard = memo(({ item }) => {
  const { cart, addToCart, updateQuantity } = useCart();
  const navigate = useNavigate();
  
  // Check if item is in cart
  const cartItem = cart.find(c => (c.food_id === item.id || c.id === item.id));
  const quantityInCart = cartItem ? cartItem.quantity : 0;
  
  // Mock logic for veg/non-veg and bestseller since they might not be in DB yet
  const isVeg = item.is_veg !== undefined ? item.is_veg : Math.random() > 0.3; 
  const isBestseller = item.is_bestseller !== undefined ? item.is_bestseller : Math.random() > 0.8;

  const handleAdd = (e) => {
    e.stopPropagation();
    addToCart(item, 1);
  };

  const handleIncrement = (e) => {
    e.stopPropagation();
    updateQuantity(item.id, parseInt(quantityInCart) + 1);
  };

  const handleDecrement = (e) => {
    e.stopPropagation();
    updateQuantity(item.id, parseInt(quantityInCart) - 1);
  };

  const goToDetails = () => {
    navigate(`/menu/${item.id}`);
  };

  return (
    <div className="food-card" onClick={goToDetails} style={{ cursor: "pointer" }}>
      <div className="food-card-img-wrapper">
        <img 
          src={`${IMAGE_URL}${item.image}`} 
          alt={item.name} 
          className="food-card-img" 
          loading="lazy" 
        />
        {isBestseller && (
          <div className="food-card-bestseller">🔥 Bestseller</div>
        )}
      </div>

      <div className="food-card-info">
        <div className={`food-veg-tag ${isVeg ? 'veg' : 'non-veg'}`}>
          <div className="food-veg-dot"></div>
        </div>
        
        <h3 className="food-card-name">{item.name}</h3>
        {item.description && (
          <p className="food-card-desc">{item.description}</p>
        )}

        <div className="food-card-footer">
          <div className="food-card-price">₹{Number(item.price).toFixed(2)}</div>
          
          {quantityInCart === 0 ? (
            <motion.button 
              className="food-add-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleAdd}
            >
              ADD
            </motion.button>
          ) : (
            <motion.div 
              className="food-qty-counter"
              layout
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
            >
              <button className="food-qty-btn" onClick={handleDecrement}>
                <Icon icon="mdi:minus" />
              </button>
              <span className="food-qty-val">{quantityInCart}</span>
              <button className="food-qty-btn" onClick={handleIncrement}>
                <Icon icon="mdi:plus" />
              </button>
            </motion.div>
          )}
        </div>
      </div>
    </div>
  );
});

export default FoodCard;
